import { Component, Input, OnChanges } from '@angular/core';
import { System } from '@app/core/resources/system';
import { CurrencyPiorityService } from '@app/core/services/currency-piority.service';
import { RatesService } from '@app/core/services/rates.service';
import { SystemsService } from '@app/core/services/systems.service';
import TransactionAmountCalculator from '@app/transactions/transaction-amount-calculator';

@Component({
    selector: 'app-best-price-tables',
    templateUrl: './best-price-tables.component.html',
    styleUrls: ['./best-price-tables.component.scss']
})
export class BestPriceTablesComponent implements OnChanges {
    @Input() public system1: System = new System();
    @Input() public system2: System = new System();
    public bestPrices: any = [];
    public system: System = new System();
    public bestBuyPrices: any = [];
    public bestSellPrices: any = [];

    public constructor(
        private systemsService: SystemsService,
        public ratesService: RatesService,
        private currencyPriorityService: CurrencyPiorityService
    ) {}

    public ngOnChanges(): void {
        if (this.system1.id === '' || this.system2.id === '') {
            return;
        }

        this.systemsService.allIncludeRates().subscribe((systems) => {
            let bestBuyPrices: Array<any> = [];
            let bestSellPrices: Array<any> = [];

            let transactionAmountCalculator: TransactionAmountCalculator = new TransactionAmountCalculator();
            this.currencyPriorityService.callbacksAndReturnByCurrency(
                this.system1,
                this.system2,
                () => {
                    systems.data
                        .filter((system) => system.attributes.currency === 'USD' && system.attributes.can_send)
                        .forEach((system) => {
                            bestBuyPrices.push({
                                price: transactionAmountCalculator.getSendAmount(this.system2, system, 1),
                                system: system,
                                link: '/b/' + this.system2.id + '/' + system.id
                            });
                            bestSellPrices.push({
                                price: transactionAmountCalculator.getReceiveAmount(this.system2, system, 1),
                                system: system,
                                link: '/b/' + system.id + '/' + this.system2.id
                            });

                            this.system = this.system2;
                        });
                },
                () => {
                    systems.data
                        .filter((system) => system.attributes.currency === 'USD' && system.attributes.can_send)
                        .forEach((system) => {
                            bestBuyPrices.push({
                                price: transactionAmountCalculator.getSendAmount(this.system1, system, 1),
                                system: system,
                                link: '/b/' + this.system1.id + '/' + system.id
                            });
                            bestSellPrices.push({
                                price: transactionAmountCalculator.getReceiveAmount(this.system1, system, 1),
                                system: system,
                                link: '/b/' + system.id + '/' + this.system1.id
                            });
                            this.system = this.system1;
                        });
                }
            );

            bestBuyPrices
                .sort((a, b) => (a.price > b.price ? 1 : -1))
                .forEach((bestBuyPrice, index) => {
                    if (index > 4) {
                        return;
                    }

                    this.bestBuyPrices[index] = bestBuyPrice;
                });

            bestSellPrices
                .sort((a, b) => (a.price > b.price ? -1 : 1))
                .forEach((bestSellPrice, index) => {
                    if (index > 4) {
                        return;
                    }

                    this.bestSellPrices[index] = bestSellPrice;
                });

            this.bestPrices = [
                {
                    title: 'Mejor precio de compra',
                    action: 'Comprar',
                    bestPrices: this.bestBuyPrices
                },
                {
                    title: 'Mejor precio de venta',
                    action: 'Vender',
                    bestPrices: this.bestSellPrices
                }
            ];
        });
    }
}
